import { ActionTree } from 'vuex';
import { RootState, UserState } from '../types';
import firebase from 'firebase';

const actions: ActionTree<UserState, RootState> = {
  setUser({commit}, payload: firebase.User) {
    if (payload) {
      commit('setUser', payload);
    } else {
      commit('clearUser');
    }
  },
};

export default actions;
